export const ADMIN_ENVIRONMENT_DEFAULT_PAGE_SIZE = 10;
export const ADMIN_ENVIRONMENT_MAX_PAGE_SIZE = 100;
export const ADMIN_ENVIRONMENT_PAGE_SIZES = [10, 25, 50, 100] as const;
